import { render, staticRenderFns } from "./NewsBlock.vue?vue&type=template&id=1afc981a"
import script from "./newsBlock.ts?vue&type=script&lang=js&external"
export * from "./newsBlock.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports